var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-page-not-found',{staticClass:"va-page-not-found-simple"},[_c('va-icon-vuestic',{attrs:{"slot":"image"},slot:"image"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }